import { merge } from '@bingads-webui/primitive-utilities';
import { isFunction, some, isEmpty } from 'underscore';
import {
  campaignSettingsStyles, budgetBidsStyles, adgroupCreationStyles,
  creationCommonStyle, dsaCampaignStyles, audienceTargetsSettingsStyles,
  audienceCampaignSettingsStyles, audienceAdgroupStyles, audienceBudgetBidsStyles,
  disclaimerPanelStyles, globalDsaCampaignStyles, sharedStylesFromSelDesign
} from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';
import {
  uiblockerStyle,
  toggleButtonStyle,
  messageBarStyle,
  searchboxStyle,
  tableStyle,
  btnStyle,
  linkStyle,
  paginationStyle,
  statusStyle,
  controlStyle,
  floatButtonStyle,
  getLocalBlockerStyle,
  advancedSettingsSectionStyle,
  containerBudgetStyle,
  locationBidGridStyle,
  keywordPlannerStyle,
  locationMapStyle,
  glyphIconStyle,
  sharedBudgetGridWrapper,
  audienceReachEstimateContainerStyle,
  selectElementStyle,
  audienceAssociationSectionStyle,
  scrollbarStyle,
  audienceModalStyles,
  audienceExpressionStyle,
  audienceCombinedListStyle,
  datePickerStyle,
  targetLocationRecommendationStyle,
  closeImageStyle,
  alertStyle,
  helpbuttonStyle,
  experimentSettingsStyle,
  entitySelectorStyle,
} from '@bingads-webui-campaign-react/common-styles';

import { getOverrideStyles } from './override';
import { getSmartShoppingCampaignOverrideStyles } from './smart-shopping-campaign-override';
import { customParamsStyle } from './custom-params';
import { getPageContainerStyles } from './page-container';

function resolveStyles({ theme }, ...styles) {
  const resolvedStyles = styles.map(s => (isFunction(s) ? s(theme) : s));

  if (some(resolvedStyles, isEmpty)) {
    throw new Error('Cannot pass in empty style!');
  }

  return resolvedStyles;
}

const glyphIconStyleOverride = (theme) => {
  const original = glyphIconStyle(theme);
  original['input[type="radio"]'] = {};
  return original;
};

export const getSettingsPageStyles = (_, theme) => {
  const { palette } = theme;

  return {
    ...getPageContainerStyles(),
    audienceAdGroupPage: {
      position: 'relative',
      minWidth: 1400,
    },
    settingsFormContainer: {
      marginLeft: '32px',
      marginBottom: '32px',
      ...merge(
        {},
        {
          '@global': merge(
            {}, ...resolveStyles(
              { theme },
              messageBarStyle,
              btnStyle,
              controlStyle,
              floatButtonStyle,
              getLocalBlockerStyle,
              glyphIconStyleOverride,
              customParamsStyle,
              scrollbarStyle,
              closeImageStyle
            ),
            experimentSettingsStyle(theme),
            getOverrideStyles(theme),
            getSmartShoppingCampaignOverrideStyles(theme)
          ),
        },
        ...resolveStyles(
          { theme },
          dsaCampaignStyles,
          campaignSettingsStyles,
          budgetBidsStyles,
          adgroupCreationStyles,
          audienceCampaignSettingsStyles,
          audienceBudgetBidsStyles,
          containerBudgetStyle,
          keywordPlannerStyle,
          searchboxStyle,
          locationBidGridStyle,
          locationMapStyle,
          sharedBudgetGridWrapper,
          tableStyle,
          toggleButtonStyle,
          linkStyle,
          selectElementStyle
        )
      ),
      ...paginationStyle(theme),
      ...alertStyle(theme),
      ...statusStyle(theme),
      ...audienceReachEstimateContainerStyle(theme, { leftMargin: 'unset', rightMargin: 440 }),
      ...audienceAssociationSectionStyle(theme, { singleListBoxWidth: 510 }),
      ...audienceTargetsSettingsStyles(theme, { companySearchTableWidth: 813, companySearchTableCompanyNameWidth: 721, companyIconHeightWidth: 32 }),
      ...audienceAdgroupStyles(theme, { creationContainerMarginLeft: 0 }),
      ...advancedSettingsSectionStyle(theme, { advancedSectionMarginLeft: 0 }),
      ...creationCommonStyle(theme, { isCreationPage: false }),
    },
    '@global': merge(
      {},
      uiblockerStyle(theme),
      datePickerStyle({ palette }),
      targetLocationRecommendationStyle({ palette }),
      glyphIconStyleOverride(theme),
      disclaimerPanelStyles({ palette }),
      globalDsaCampaignStyles({ palette }),
      {
        '.ui-next-summary-bar .summary-bar-settings .fall-back-settings': {
          display: 'none',
        },
        '.audience-modal.create-audience': {
          width: 700,
        },
        '.ima-reach-warning-container': {
          marginLeft: '15px',
          marginTop: '5px',
          marginBottom: '15px',
        },
      },
      audienceModalStyles(theme, { modalWidth: 500 }),
      audienceExpressionStyle(),
      audienceCombinedListStyle({ palette }),
      helpbuttonStyle(theme),
      sharedStylesFromSelDesign(),
      entitySelectorStyle({ palette }),
      paginationStyle({ palette })
    ),
  };
};
